import styled from '@emotion/styled'
import { FormControl, FormLabel, Stack } from '@chakra-ui/core'

export const StyledFormLabel = styled(FormLabel)<{ required?: boolean }>`
  font-weight: 400;
  font-size: 14px;
  display: flex;
  align-items: center;
  column-gap: 10px;
  height: 24px;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  padding: 0 !important;

  ${(props) =>
    props.required &&
    `
    &::after {
      content: '*';
      color: red;
      font-size: 16px;
      margin-left: 2px;
      margin-right: 2px;
      vertical-align: middle;
      line-height: 1;
    }
  `}
`

export const StyledFormControl = styled(FormControl)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
export const StyledStack = styled(Stack)`
  flex-direction: row;
  column-gap: 10px;
`
